import React, { useEffect, useRef, useState } from 'react';
import { statsData } from '../data/mockData';

const AnimatedNumber = ({ value, suffix, isVisible }) => {
  const numVal = parseInt(value);
  const [displayValue, setDisplayValue] = useState(numVal);
  const hasAnimated = useRef(false);

  useEffect(() => {
    if (!isVisible || hasAnimated.current) return;
    hasAnimated.current = true;
    setDisplayValue(0);

    const totalSteps = Math.min(numVal, 40);
    const stepSize = numVal / totalSteps;
    const intervalTime = 800 / totalSteps;
    let current = 0;

    const timer = setInterval(() => {
      current += stepSize;
      if (current >= numVal) {
        setDisplayValue(numVal);
        clearInterval(timer);
      } else {
        setDisplayValue(Math.floor(current));
      }
    }, intervalTime);
    return () => clearInterval(timer);
  }, [isVisible, numVal]);

  return (
    <span className="text-[#0A3900] text-right">
      {/* Numbers: 120px, weight 300 */}
      <span className="text-[56px] sm:text-[80px] lg:text-[120px] font-light leading-[0.7]">
        {displayValue}
      </span>
      <span className="text-[32px] sm:text-[48px] lg:text-[120px] font-light leading-[0.7]">
        {suffix}
      </span>
    </span>
  );
};

const StatsSection = () => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.05, rootMargin: '100px' }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-[#F9FBF5] py-16 lg:py-24">
      <div className="max-w-[1121px] mx-auto px-6 lg:px-10">
        {/* Title: 64px, weight 300, tracking -0.704px */}
        <h2 className="text-[#0A3900] text-[36px] lg:text-[64px] font-light leading-[1] tracking-[-0.011em] mb-10 lg:mb-16">
          {statsData.title}
        </h2>

        <div className="space-y-0">
          {statsData.stats.map((stat, i) => (
            <div key={i}>
              <div className="flex items-end justify-between py-4 lg:py-5">
                {/* Label: 24px, weight 400 */}
                <p className="text-[#0A3900] text-[16px] lg:text-[24px] font-normal leading-[1] max-w-[220px]">
                  {stat.label}
                </p>
                <AnimatedNumber
                  value={stat.value}
                  suffix={stat.suffix}
                  isVisible={isVisible}
                />
              </div>
              {i < statsData.stats.length - 1 && (
                <div className="h-[1px] bg-[#082900]/15" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
